import { Box, Flex, HStack, Text, VStack } from '@chakra-ui/react'
import { addMetadata, formatValue, useApp } from '@hb/react'
import {
  ASSESSMENTS,
  colors,
  makeAllFieldsOptional,
  planDesignField,
  signOnFields,
} from '@hb/shared'
import { useMemo } from 'react'
import { useProfile } from '../../contexts/user/ProfileContext'
import { useUpdateDoc } from '../../hooks/backend/useUpdateDoc'
import { DataView } from '../DataView/DataView'
import { SignOnRemindersView } from '../Users/Profile/Assessments/SignOnRemindersView'
import { SkipToSignOn } from '../Users/Profile/Assessments/SkipToSignOn'
import { AssessmentFaxes } from './AssessmentFaxes'
import { AssessmentQuestionnaireView } from './AssessmentModal/QuestionnaireView'
import { SignOnStatus } from './SignOn/SignOnStatus'

const optionalSignOnFields = makeAllFieldsOptional(signOnFields)
export const QuestionnairesPanel = ({
  mobileLayout,
  width,
}: {
  mobileLayout: boolean
  width: number
}) => {
  const { appName } = useApp()
  const {
    selectedAssessment: { ref, populated: selectedAssessment },
    assessmentId,
    user,
  } = useProfile()

  const { signOnData, signOnCorrections, insuranceCoverage } = selectedAssessment ?? {}
  const { memberId, 'plan-design-and-state-mandates': planDesignAndStateMandates } =
    user?.insurancePlans?.primary ?? {}
  const { planDesign } = planDesignAndStateMandates ?? {}
  const planDesignText = useMemo(() => {
    if (!planDesign) return ''
    return `${formatValue({ field: planDesignField, value: planDesign })}`
  }, [planDesign])
  const update = useUpdateDoc('Sign on data')

  return (
    <VStack w="100%">
      {appName === 'app' ? <SignOnStatus width={width} /> : null}
      <Flex flexFlow={mobileLayout ? 'column' : 'row'} gap={2} align="center" w="100%">
        <Flex w="100%" gap={2} align="center" flex={mobileLayout ? 'unset' : 1}>
          <SignOnRemindersView />
          <HStack
            px={3}
            bg={colors.green.hex}
            minW="0"
            py={1}
            flex={1}
            color="white"
            textShadow="1px 1px 1px rgba(0,0,0,0.5)"
            fontFamily="Comfortaa"
            borderRadius={3}
            spacing={0.5}
            boxShadow="md">
            <Text minW="0" isTruncated mr="4px" fontSize="sm" fontWeight={600}>
              {`${insuranceCoverage} Member ID:`}
            </Text>
            <Text fontWeight={500} fontFamily="Hero-New">
              {typeof memberId === 'string' ? memberId || 'None' : 'None'}
              {planDesignText ? ` - ${planDesignText}` : ''}
            </Text>
          </HStack>
          {!mobileLayout && appName === 'app' ? <SkipToSignOn mobileLayout={mobileLayout} /> : null}
        </Flex>
        {mobileLayout && appName === 'app' ? (
          <Flex w="100%" gap={2} align="center">
            <SkipToSignOn mobileLayout={mobileLayout} />
          </Flex>
        ) : null}
      </Flex>
      <Flex flexFlow={mobileLayout ? 'column' : 'row'} w="100%" gap={2}>
        {appName === 'providers-app' && assessmentId ? (
          <Box flex={mobileLayout ? 'unset' : 1}>
            <AssessmentQuestionnaireView assessmentId={assessmentId} />
          </Box>
        ) : null}
        <Box bg="white" borderRadius={4} boxShadow="md" flex={mobileLayout ? 'unset' : 1}>
          {/* <Box p={2}>
            {appName === 'providers-app' ? <SignOnStatus width={width / 2 - 10} /> : null}
          </Box> */}
          <DataView
            initExpanded
            withEditModal
            adminView
            childrenExpanded
            onSubmit={data =>
              update(ref, 'signOnCorrections', addMetadata(data, appName, !signOnCorrections))
            }
            baseStoragePath={`${ASSESSMENTS}/${assessmentId}/signOnCorrections`}
            updateField={(path, value) => update(ref, `signOnCorrections.${path}`, value)}
            field={optionalSignOnFields}
            corrections={signOnCorrections}
            data={signOnData}
          />
        </Box>
      </Flex>
      {/* <InsuranceCardsView /> */}
      {appName === 'app' ? <AssessmentFaxes /> : null}
    </VStack>
  )
}
